<!--标签维护-->
<template>
    <div>
        <van-nav-bar :title="title" />
        <van-field
                v-model="tagName"
                name="标签名"
                label="标签名"
                placeholder="标签名"
                :required="true"
                :rules="[{ required: true, message: '宝,要填写标签名哦' }]"
        />
      <van-row type="flex" style="margin-top: 20px">
        <van-col span="24" >
                <span v-for="tag in tags" :key="tag.tagId" style="margin-left: 5px">
                    <van-tag  plain   :type="isSelect(tag.statusCd)" @click="clickTag(tag)" @dblclick="dbclickTag(tag,$event)" style="margin-top:5px" >{{tag.attrName}}</van-tag>
                </span>
        </van-col>
      </van-row>
      <span style="float: left;color:#969799;font-size: 12px;margin-top: 10px;margin-bottom: 10px"> * 操作提示:单击标签进行修改;双击标签启用/停用</span>
      <van-button style="margin-top: 15px;margin-bottom: 15px" type="primary" plain
                  block round color="#fe7844" :loading="isLoading"
                  loading-text="提交中..." size="small"
                  @click="submitForm">提交</van-button>
      <van-nav-bar title="标签分类绑定" />

      <van-cell-group >
        <van-field
            readonly
            clickable
            label="类型/明细"
            :value="sortAndDetail"
            placeholder="请选择"
            @click="showSortPicker = true"

        />
        <!--  :lazy-render="false" 未弹出组件时渲染     -->
        <van-popup v-model="showSortPicker" position="bottom" :lazy-render="false">
          <van-picker show-toolbar title="类型/明细" ref="sortPicker"
                      :columns="sortAndDetails"
                      value-key="attrName"
                      @cancel="showSortPicker = false"
                      @confirm="onSortConfirm"/>
        </van-popup>
        <van-button style="margin-top: 15px;margin-bottom: 15px" type="info" plain
                    block round :loading="isBandLoading"
                    loading-text="绑定中..." size="small"
                    @click="submitBand">绑定</van-button>
      </van-cell-group>
    </div>


</template>

<script>
    import * as MyApi from '@/api/URLApiAddr.js'
    import {SAVE_TYPES_TAGS} from "@/api/URLApiAddr.js";
    export default {
        name: "TagPage",
        data(){
            return {
              title: "标签维护",
              tagName : '',
              tagId : Number,
              isLoading: false,
              isBandLoading: false,
              tags:[],
              showSortPicker: false,
              sortAndDetail: '',
              sortAndDetails: [],
              formModel:{
                tagId: Number,
                typeId: Number,
                typeChildId: Number
              }
            }
        },
        mounted(){
            this.initTags()
        },



      methods: {
            async submitForm(){
                this.isLoading = true

                let flag = await this.modSysTag(this.tagId,this.tagName,null)
                if(flag){
                    this.tagId = Number
                    this.tagName = ''
                }
                this.initTags()
                this.isLoading = false
            },
            submitBand(){
              let params = {
                "tagId": this.tagId,
                "typeId": this.formModel.typeId,
                "typeChildId": this.formModel.typeChildId
              }
              this.isBandLoading = true;

              this.$axios.post(MyApi.SAVE_TYPES_TAGS,params/*,options*/)
                  .then((response) =>  {
                    let code = response.code;
                    if(code == '200'){
                      this.isBandLoading =  false;
                    }
                  })
                  .catch((err) =>{
                    this.isBandLoading =  false;
                  })
            },
            initTags(){
                let params = {"all":"Y"};
                this.$axios.post(MyApi.FIN_QRY_TAGS,params/*,options*/)
                    .then((response) =>  {
                        debugger
                        let code = response.code;
                        if(code == '200'){
                            this.tags = response.data.tags
                        }
                    })
                    .catch((err) =>{
                        this.$toast.fail("查询异常"+err);
                    })
              // 初始化分类
                let attr = {attrIds:[10]}
                this.$axios.post(MyApi.QRY_ATTR_LIST_BY_PARID,attr).then((resp) => {
                  let sortDetails = resp.data.sort
                  this.sortAndDetails = sortDetails
                  this.formModel.typeId = sortDetails[0].attrId
                  this.formModel.typeChildId = sortDetails[0].children[0].attrId
                  this.sortAndDetail = sortDetails[0].attrName + " " + sortDetails[0].children[0].attrName

                }).catch((error) => {
                  console.log(error)
                  this.$toast.fail("数据初始化异常");
                })
            },
            isSelect(statusCd){
                //生效状态
                if("1000" == statusCd){
                    return "primary"
                }else{
                    return "default"
                }
            },
            clickTag(tag){
                this.tagName = tag.attrName
                this.tagId = tag.attrId
            },
            async dbclickTag(tag,event){
                const toast = this.$toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: '修改中,请稍后',
                });
                debugger;
                //如果没有default,说明是已经选中的标签
                if(event.target.className.indexOf('van-tag--default') == -1){
                    //取消选中
                    let flag = await this.modSysTag(tag.attrId,null,"1100")
                    if(flag){
                        event.target.classList.replace('van-tag--primary','van-tag--default')
                        toast.clear()
                    }
                }else{
                    //选中
                    let flag = await this.modSysTag(tag.attrId,null,"1000")
                    if(flag){
                        event.target.classList.replace('van-tag--default','van-tag--primary')
                        toast.clear()
                    }
                }


            },
            async modSysTag(tagId,tagName,statusCd){
                let params = {
                    "attrId": tagId,
                    "attrName": tagName,
                    "statusCd": statusCd
                }
                let res = false;

                await this.$axios.post(MyApi.MOD_SYS_TAGS,params/*,options*/)
                    .then((response) =>  {
                        debugger
                        let code = response.code;
                        if(code == '200'){
                            res =  true;
                        }
                    })
                    .catch((err) =>{
                    })
                return res;

            },
          onSortConfirm(value) {
            let index = this.$refs.sortPicker.getIndexes()
            let sortIndex = index[0];
            let detailIndex = index[1];
            this.formModel.typeId = this.sortAndDetails[sortIndex].attrId
            this.formModel.typeChildId = this.sortAndDetails[sortIndex].children[detailIndex].attrId
            this.sortAndDetail = value[0] + " " + value[1];
            this.showSortPicker = false;
          }
        }
    }
</script>

<style scoped>

</style>
